import { api_create_corporate_lead_path } from '../../routes';
import request from './request';

export interface CreateCorporateLeadParams {
  corporate_lead: {
    name?: string;
    email: string;
    job_title?: string;
    company_name?: string;
    possible_number_of_users?: string;
  };
}

export interface CreateCorporateLeadResponse {
  success: boolean;
  existingEntries: boolean;
}

export async function createCorporateLead(
  params: CreateCorporateLeadParams
): Promise<CreateCorporateLeadResponse> {
  const res = await request('post', api_create_corporate_lead_path(params));
  return res;
}
